<template>
  <div>
    <div class="block xl:px-4 py-2 text-xs text-gray-400">
      {{ $trans('app.menu.my-account') }}
    </div>

    <jet-dropdown-link :href="route('profile.show')">
      {{ $trans('app.menu.profile') }}
    </jet-dropdown-link>

    <jet-dropdown-link :href="route('coach.account')" v-if="$page.props.user.role === 'coach'">
      {{ $trans('app.menu.coach.account') }}
    </jet-dropdown-link>

    <jet-dropdown-link :href="route('submission.myresults')">
      {{ $trans('app.menu.my-results') }}
    </jet-dropdown-link>

    <div class="border-t border-gray-100 hidden xl:block"></div>

    <!-- Authentication -->
    <form @submit.prevent="logout">
      <jet-dropdown-link as="button">
        {{ $trans('app.menu.logout') }}
      </jet-dropdown-link>
    </form>
  </div>
</template>
<script>
import JetDropdownLink from '@/Jetstream/DropdownLink'

export default {
  name: 'menu-account-content',
  components: {JetDropdownLink},
  props: {
    //
  },
  methods: {
    logout() {
      this.$inertia.post(route('logout'));
    },
  }
}
</script>
